import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const applyDeepLink = factory("APPLY_DEEP_LINK");
